












import { Component, Prop,Vue } from "vue-property-decorator";

@Component({
    "model": {
        "prop": "modelValue",
        "event": "change"
    },
})
export default class OptionInput<OptionValueType> extends Vue {
    @Prop({ required: true })
    value!: OptionValueType;

    @Prop({ required: true })
    modelValue!: OptionValueType;

    @Prop({ required: true })
    name!: string;

    @Prop({ default: false })
    disabled!: boolean;

    get radioButtonValue() {
        return this.modelValue
    }

    set radioButtonValue(value: OptionValueType) {
        this.$emit("change", value)
    }
}
